import { client } from '..';
import { DenominationsTypesResponse } from '../models/denominationModels';

export const getDenominationsTypes = async (): Promise<DenominationsTypesResponse[]> => {
  const { data } = await client.get('/denominations/types');
  return data;
};
